module.exports = __webpack_public_path__ + "static/media/NNL-signup.ce9e8bad.jpg";